export default __webpack_public_path__ + "static/media/process.65731878.svg";